import plur from 'plur';
import { isEmptyString } from '@/utils/string';
import type { PromoCode } from '@/services/signup/api';

/**
 * The coupon banner's sentence. `duration_period` is a bare string on the wire
 * and is not always a month count — `forever` and `''` both occur (the checkout
 * transform guards the same field) — so the duration clause is dropped unless
 * it parses as a positive number. Interpolating raw, as the funnel this replaces
 * did, reads "off for forever months".
 */
export function promoBannerDescription(promo: PromoCode): string {
  const { discount_value: percentOff, duration_period: durationPeriod } = promo.config;
  const months = isEmptyString(durationPeriod) ? Number.NaN : Number(durationPeriod);

  if (!Number.isFinite(months) || months <= 0) {
    return `You'll receive ${percentOff}% off.`;
  }

  return `You'll receive ${percentOff}% off for ${months} ${plur('month', months)}.`;
}
